export const settingsHelperFunctions ={
    handleSettingValue(setting) {
        if (setting.settingType === "BOOLEAN") {
            if(setting.value === null || setting.value === undefined){
                setting.value = "FALSE";
            }
            if (setting.value.toString().toUpperCase() === "FALSE") {
                return (
                    "<div class='form-check form-switch'>" +
                    "<input class='form-check-input' type='checkbox' id='" +
                    setting.name +
                    "' value='false'/>" +
                    "</div>"
                );
            } else {
                return (
                    "<div class='form-check form-switch'>" +
                    "<input class='form-check-input' type='checkbox' id='" +
                    setting.name +
                    "' value='true' checked/>" +
                    "</div>"
                );
            }
        } else if (setting.settingType === "DOUBLE") {
            if(setting.value === null || setting.value === undefined){
                setting.value = 0.0;
            }
            var floatValue = parseFloat(setting.value).toFixed(2);
            return (
                "<div>" +
                "<input type='number' min='0.00' step='0.01' id='" +
                setting.name +
                "' value='" +
                floatValue +
                "'>" +
                "</div>"
            );
        } else if (setting.settingType === "INTEGER") {
            if(setting.value === null || setting.value === undefined){
                setting.value = 0.0;
            }
            var intValue = parseInt(setting.value);
            return (
                "<div>" +
                "<input type='number' id='" +
                setting.name +
                "' value='" +
                intValue +
                "'>" +
                "</div>"
            );
        } else if (setting.settingType === "ARRAY") {
            var rawArray = setting.value
                .toString()
                .substring(18, setting.value.length - 1);
            return (
                "<div class='string-setting-input'>" +
                "<input type='text' style='width: 100%;' id='" +
                setting.name +
                "' value='" +
                rawArray +
                "'>" +
                "</div>"
            );
        } else {
            if(setting.value === null || setting.value === undefined || setting.value === "null"){
                setting.value = "";
            }
            if( setting.encrypted === true){
                return (
                    "<div class='string-setting-input'>" +
                    "<input type='password' style='width: 100%;' id='" +
                    setting.name +
                    "' value='" +
                    setting.value +
                    "'>" +
                    "</div>"
                );
            }else{
                return (
                    "<div class='string-setting-input'>" +
                    "<input type='text' style='width: 100%;' id='" +
                    setting.name +
                    "' value='" +
                    setting.value +
                    "'>" +
                    "</div>"
                );
            }

        }
    },
    valueIsNotInt(value) {
        if (value == null || value == undefined) {
            value = 0;
        }
        return !/^\d+$/.test(value.toString());
    },
    valueIsNotDouble(value) {
        if (value === null || value === undefined) {
            value = 0.0;
        }

        // Changing value into double if is integer type
        if (/^\d+$/.test(value.toString())) {
            value = value + ".00";
        }

        return (
            !/^\d*[.]\d+$/.test(value.toString()) &&
            !/^\d*[,]\d+$/.test(value.toString())
        );
    },
    getRoundedValue(value) {
        if (this.valueIsNotDouble(value)) {
            return value;
        } else {
            if (value === null || value === undefined || value === "") {
                value = 0.0;
            }

            return parseFloat(value).toFixed(2);
        }
    },
    getTrimName(name) {
        if (name && name.length > 35) {
            return name.substr(0, 35) + "...";
        }
        return name;
    },
}


